import styled from "@emotion/styled"
import { findIndex, get } from "lodash"
import React, { useContext } from "react"
import tw from "twin.macro"
import Container from "./Container"
import Content from "./Content"
import ThemeContext from "../context/theme-context"

export const StyledSection = styled.div`
  ${tw`py-12 bg-cover`}
  ${props => props.removeTopSpacing && tw`pt-0`}
  ${props => props.removeBottomSpacing && tw`pb-0`}
  ${(props) =>
    ({
      teal: tw`bg-teal`,
      white: tw`bg-white`,
    }[props.backgroundColor] || tw`bg-white`)}
  &.lazyloaded {
    ${(props) =>
      props.backgroundImage && `
        background-image: url('${props.backgroundImage.url}?w=1600=jpg&q=85&auto=format');
        @media only screen and (min-resolution: 144dpi) {
          background-image: url('${props.backgroundImage.url}?w=1600fm=jpg&q=50&dpr=2&auto=format');
        }
      `}
  }
`

const Section = ({ section }) => {
  const alignText = get(section, "elements.align_text.value[0].codename")
  const backgroundColor = get(
    section,
    "elements.background_color.value[0].codename"
  )
  const backgroundImage = get(
    section,
    "elements.background_image.value[0].elements.image.value[0]"
  )
  const content = get(section, "elements.content.value")
  const options = get(section, "elements.options.value") || []
  const width = { small: "sm", default: "default" }[
    get(section, "elements.width.value[0].codename") || "default"
  ]
  const contrastText =
    findIndex(options, { codename: "contrast_text" }) !== -1 ? true : false
    const { hydrated: isClient } = useContext(ThemeContext)

  return (
    <StyledSection
      className={`${isClient ? 'lazyload' : ''}`}
      backgroundColor={backgroundColor}
      backgroundImage={backgroundImage}
    >
      <Container width={width}>
        <Content
          blocks={content}
          contrastText={contrastText}
          alignText={alignText}
        />
      </Container>
    </StyledSection>
  )
}

export default Section
